/**
 * «Invita y gana» (2-10-2026): enlaces de compartir. Los comparte el propio usuario desde su móvil o su navegador;
 * nuestros servidores nunca escriben a sus contactos (sin consentimiento sería correo no solicitado).
 */
export const shareUrls = ({ link, text, subject }) => {
  const u = encodeURIComponent(link);
  const t = encodeURIComponent(text);
  return {
    whatsapp: `https://wa.me/?text=${encodeURIComponent(`${text} ${link}`)}`,
    telegram: `https://t.me/share/url?url=${u}&text=${t}`,
    email: `mailto:?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(`${text}\n\n${link}`)}`,
    linkedin: `https://www.linkedin.com/sharing/share-offsite/?url=${u}`,
    x: `https://twitter.com/intent/tweet?text=${t}&url=${u}`,
    facebook: `https://www.facebook.com/sharer/sharer.php?u=${u}`,
  };
};
